import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { GlobalService } from '../../../core/global.service';
import { PartnerRelationship } from '../../models/PartnerRelationship';

@Component({
  selector: 'app-partnership-details',
  templateUrl: './partnership-detail.component.html',
  styleUrls: ['./partnership-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PartnershipDetailComponent implements OnInit {
  relationshipId: number;
  selectedPartner: string;
  partnership: PartnerRelationship;
  displayDialog: boolean;
  refresh = false;
  managePartnerUri: string;

  constructor(private _global: GlobalService) { }

  ngOnInit() {
    this.relationshipId = this._global.find((<any>_GlobalNS).paths.RelationshipId);
    this.managePartnerUri = (<any>_GlobalNS).routes.person.ManagePartner;
  }

  selectPartner(partnerName: string): void {
    this.selectedPartner = partnerName;
  }

  partnerDetailsChange(partner: PartnerRelationship): void {
    this.partnership = partner;
    this.refresh = false;
  }

  refreshRelationships(): void {
    this.refresh = true;
  }

  editPartner() {
    this.displayDialog = true;
    this.refresh = false;
  }

  onDialogClose(flag: boolean): void {
    this.displayDialog = flag;
  }
}
